<template>
  <select-response-auto-complete
    ref="rfq2-select"
    :model="value"
    @update:model="$emit('update:value', $event)"
    @on-change="$emit('on-change', $event)"
    :columns="columns"
    api="RFQ2s/GetAllDynamic"
    :selected="selected"
    searchAllColumns
    :fields="{id: 'id', title: 'rfqid'}"
    :orderBy="{ fields: 'id', order: 'desc' }"
    :filters="`chosen == false`"
  />
</template>

<script>
import { filterStartsWith } from '@/utils/shared'

export default {
  name: 'SearchRFQ2s',
  props: {
    value: {
      required: true
    }
  },
  computed: {
    columns () {
      return [
        { title: this.L10n('entry-date'), value: 'entryDate', type: 'date' },
        { title: this.L10n('part-number'), value: 'partNumber', originField: 'part.partNumber', type: 'custom', customFilter: filterStartsWith },
        { title: this.L10n('part-sn'), value: 'partSN', originField: 'partSN', type: 'string' },
        { title: this.L10n('supplier'), value: 'supplierCompanyName', originField: 'supplierCompany.name', type: 'string' },
        { title: this.L10n('qty'), value: 'qty', originField: 'qty', type: 'number' },
        // eslint-disable-next-line
        { title: this.L10n('price'), value: 'price', template: '${data.price || ""} ${data.currencyTitle || ""}', originField: 'price', type: 'number' },
        { title: this.L10n('condition'), value: 'conditionTitle', originField: 'condition.title', type: 'string' },
        { title: this.L10n('remarks'), value: 'remarks', originField: 'remarks', type: 'string' }
      ]
    },
    selected () {
      return [
        'id', 'rfqid', 'entryDate', 'partID', 'partSN', 'part.partNumber as partNumber', 'supplierCompany.name as supplierCompanyName',
        'qty', 'price', 'currency.title as currencyTitle', 'remarks', 'condition.title as conditionTitle'
      ].join(',')
    }
  }
}
</script>
